<div class="layout-footer">
    <img src="assets/Pramukh.png" alt="Logo" height="20" />
    by
    <span class="font-medium ml-2">PRAMUKH</span>
</div>
